import { reactive } from "vue";

const state = reactive({
    active: false,
    shoppingBag: false,
    profileBar: false,
    notification: false,
    subscription: {
        open: false,
        subscriptionList: [],
        price: 0,
        callbackConfirm: null,
        type: 'online'
    },
});

const methods = {
    open: function () {
        state.active = true;
    },
    close: function () {
        state.active = false;
    },
    openShoppingBag: function () {
        state.shoppingBag = true;
    },
    closeShoppingBag: function () {
        state.shoppingBag = false;
    },
    openProfileBar: function () {
        state.profileBar = true;
    },
    closeProfileBar: function () {
        state.profileBar = false;
    },
    toggleSideMenu: function(target, val = null){
        console.log(target, val);
        if(target == "notification"){
            state.notification = val == null ? !state.notification : val
        }
    },
    openSubscription: function (subscriptionList,price,type,callbackConfirm) {
        state.subscription.open = true;
        state.subscription.subscriptionList = subscriptionList;
        state.subscription.price = price;
        state.subscription.type = type;
        state.subscription.callbackConfirm = callbackConfirm;
    },
    sendCallbackSubscription : function(data){
        if (state.subscription.callbackConfirm) {
            state.subscription.callbackConfirm(data);
        }
    },
    getSubscriptionList: function () {
        return state.subscription.subscriptionList;
    },
    getPrice: function () {
        return state.subscription.price;
    },
    getType: function () {
        return state.subscription.type;
    },
    closeSubscription: function () {
        state.subscription.open = false;
    },
};

export default {
    state: state,
    methods: methods,
}
